export const PENDO_FIRST_STEPS_TASK_LIST_ID = 'ih5ikxkt0n'
export const PENDO_START_DEMO_ID = 'pendo-start-demo-button'
export const PENDO_LOAD_TIMEOUT_MS = 30_000
export const PENDO_PAGELOAD_DELAY_MS = 200
export const PENDO_READY_EVENT = 'pendo-ready'
export const PENDO_SCRIPT_LOADED_EVENT = 'pendo-script-loaded'
